import { EconomicSectorId } from "../../warmi/my-account/model/economic-sector.models";
import { ProjectType } from "../../warmi/my-account/model/project-settings.model";
import { PagesId } from "./pages.config"; 

export class PaginatorResponse {
  content: any[];
  pageable: {};
  first : boolean;
  numberOfElements : number;
  total : number;
}

export class PagesAndComponentsConfigModel{
  projectType : string[] | null;
  economicSectorIds : number[] | null;
  pageId : number | null;
  componentCode : string | null;
  configuration : {[x : string] : boolean} | null;
  available : boolean;
}

export enum MoonflowComponentId {
  TEMPLATE_LIST_COMPONENT = "TEMPLATE_LIST_COMPONENT"
}

export enum ComponentCodeConfiguration {
  TEMPLATE_LIST_COMPONENT_FIELD_MANAGEMENT = "TEMPLATE_LIST_COMPONENT_FIELD_MANAGEMENT",
  EVENT_VIEW_COMPONENT_RECOVERY_PORTFOLIO = "EVENT_VIEW_COMPONENT_RECOVERY_PORTFOLIO",
  ACCOUNTS_RECEIVABLE_RECOVERY_PORTFOLIO_TAB = "ACCOUNTS_RECEIVABLE_RECOVERY_PORTFOLIO_TAB",
  EVENT_VIEW_COMPONENT_NEW_DOCUMENT_EVENT = "EVENT_VIEW_COMPONENT_NEW_DOCUMENT_EVENT",
  ACCOUNTS_RECEIVABLE_INTERACTION_TAB = "ACCOUNTS_RECEIVABLE_INTERACTION_TAB",
  CHANNEL_MANAGEMENT_VIEW_SCHEDULE_CONFIGURATION_TAB = "CHANNEL_MANAGEMENT_VIEW_SCHEDULE_CONFIGURATION_TAB",
  CHANNEL_MANAGEMENT_VIEW_CONTACTABILITY_CONFIGURATION_TAB = "CHANNEL_MANAGEMENT_VIEW_CONTACTABILITY_CONFIGURATION_TAB",
  CHAT_COMPONENT_FIELD_MANAGEMENT_TAB = "CHAT_COMPONENT_FIELD_MANAGEMENT_TAB",
  MESSENGER_COMPONENT_FIELD_MANAGEMENT_TAB = "MESSENGER_COMPONENT_FIELD_MANAGEMENT_TAB",
  COMMUNICATIONS_COMPONENT_SMS_TAB = "COMMUNICATIONS_COMPONENT_SMS_TAB",
  TEMPLATE_LIST_COMPONENT_EXTERNAL = "TEMPLATE_LIST_COMPONENT_EXTERNAL",

}

export const PagesAndComponentsConfigData : PagesAndComponentsConfigModel[] = [
  {
    projectType : [ProjectType.BUSINESS],
    economicSectorIds : null,
    pageId : null,
    componentCode : MoonflowComponentId.TEMPLATE_LIST_COMPONENT,
    configuration : {
    },
    available : true
  },
  {
      projectType : [ProjectType.BUSINESS],
      economicSectorIds : null,
      pageId : PagesId.EVENT,
      componentCode : null,
      configuration : {
        //[ComponentCodeConfiguration.EVENT_VIEW_COMPONENT_RECOVERY_PORTFOLIO] : false
      },
      available : true
  },
  {
    projectType : [ProjectType.BUSINESS],
    economicSectorIds : null,
    pageId : PagesId.WEB_FORM,
    componentCode : null,
    configuration : {},
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS],
    economicSectorIds : null,
    pageId : PagesId.RECOVERY_PORTFOLIO,
    componentCode : null,
    configuration : {},
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS],
    economicSectorIds : null,
    pageId : PagesId.COMMUNICATIONS,
    componentCode : null,
    configuration : {
        [ComponentCodeConfiguration.COMMUNICATIONS_COMPONENT_SMS_TAB] : false,
    },
    available : true
  },
  {
    projectType : [ProjectType.CLIENTS],
    economicSectorIds : null,
    pageId : PagesId.EVENT,
    componentCode : null,
    configuration : {
        //[ComponentCodeConfiguration.EVENT_VIEW_COMPONENT_NEW_DOCUMENT_EVENT] : false,
    },
    available : true
  },
  {
    projectType : [ProjectType.CLIENTS],
    pageId : PagesId.RECOVERY_PORTFOLIO,
    componentCode : null,
    economicSectorIds : null,
    configuration : {},
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS, ProjectType.CLIENTS],
    economicSectorIds : [EconomicSectorId.CONSORTIA_ADMINISTRATOR, EconomicSectorId.CLUB_RECREATION, EconomicSectorId.EDUCATION, EconomicSectorId.REAL_ESTATE, EconomicSectorId.OTHER_ACTIVITY, EconomicSectorId.HEALTH_SERVICES, EconomicSectorId.PROFESSIONAL_SERVICES, EconomicSectorId.TELECOMMUNICATIONS, EconomicSectorId.DIRECT_SELLING, EconomicSectorId.GENERAL_GOODS_SERVICES, EconomicSectorId.INSURANCES, EconomicSectorId.UTILITIES],
    pageId : PagesId.CHANNEL_MANAGEMENT,
    componentCode : null,
    configuration : {
        [ComponentCodeConfiguration.CHANNEL_MANAGEMENT_VIEW_SCHEDULE_CONFIGURATION_TAB] : false,
        [ComponentCodeConfiguration.CHANNEL_MANAGEMENT_VIEW_CONTACTABILITY_CONFIGURATION_TAB] : false,
    },
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS, ProjectType.CLIENTS],
    economicSectorIds : [EconomicSectorId.CONSORTIA_ADMINISTRATOR, EconomicSectorId.CLUB_RECREATION, EconomicSectorId.EDUCATION, EconomicSectorId.REAL_ESTATE, EconomicSectorId.OTHER_ACTIVITY, EconomicSectorId.HEALTH_SERVICES, EconomicSectorId.PROFESSIONAL_SERVICES, EconomicSectorId.TELECOMMUNICATIONS, EconomicSectorId.DIRECT_SELLING, EconomicSectorId.GENERAL_GOODS_SERVICES, EconomicSectorId.INSURANCES, EconomicSectorId.UTILITIES],
    pageId : PagesId.EVENT,
    componentCode : null,
    configuration : {
        [ComponentCodeConfiguration.EVENT_VIEW_COMPONENT_RECOVERY_PORTFOLIO] : false,
    },
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS, ProjectType.CLIENTS],
    economicSectorIds : [EconomicSectorId.CONSORTIA_ADMINISTRATOR, EconomicSectorId.CLUB_RECREATION, EconomicSectorId.EDUCATION, EconomicSectorId.REAL_ESTATE, EconomicSectorId.OTHER_ACTIVITY, EconomicSectorId.HEALTH_SERVICES, EconomicSectorId.PROFESSIONAL_SERVICES, EconomicSectorId.TELECOMMUNICATIONS, EconomicSectorId.DIRECT_SELLING, EconomicSectorId.GENERAL_GOODS_SERVICES, EconomicSectorId.INSURANCES, EconomicSectorId.UTILITIES],
    pageId : PagesId.WEB_FORM,
    componentCode : null,
    configuration : {},
    available : true
  },
  {
    projectType : [ProjectType.BUSINESS, ProjectType.CLIENTS],
    pageId : PagesId.ACCOUNTS_RECEIVABLE_CREDIT,
    componentCode : null,
    economicSectorIds : [
      EconomicSectorId.CONSORTIA_ADMINISTRATOR,
      EconomicSectorId.CLUB_RECREATION,
      EconomicSectorId.EDUCATION,
      EconomicSectorId.COLLECTIONS_COMPANY,
      EconomicSectorId.REAL_ESTATE,
      EconomicSectorId.OTHER_ACTIVITY,
      EconomicSectorId.HEALTH_SERVICES,
      EconomicSectorId.PROFESSIONAL_SERVICES,
      EconomicSectorId.TELECOMMUNICATIONS,
      EconomicSectorId.DIRECT_SELLING,
      EconomicSectorId.GENERAL_GOODS_SERVICES,
      EconomicSectorId.INSURANCES,
      EconomicSectorId.UTILITIES
    ],
    configuration : {},
    available : false
  },
  {
    projectType : [ProjectType.BUSINESS, ProjectType.CLIENTS],
    pageId : PagesId.PAYMENT_ORDERS,
    componentCode : null,
    economicSectorIds : [],
    configuration : {},
    available : true
  },
];
